import axios from 'axios'

const zendesk = {
  namespaced: true,

  state() {
    return {
      data: {
        ssoUrl: null,
        token: null,
      },
    };
  },

  mutations: {
    setData(state, data) {
      state.data.ssoUrl = data.sso_url;
      state.data.token = data.token;
    },
    resetData(state) {
      state.data.ssoUrl = null;
      state.data.token = null;
    },
  },

  actions: {
    sso({commit}) {
      return new Promise((resolve, reject) => {
        commit('resetData');
        axios.get('/api/zendesk/sso').then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch((error) => {
          const message = [
            'FAQの認証に失敗しました。', 
            '重調@CITYの認証後に、もう一度お試しください。',
          ];
          commit('setFlashMessage', {value: message.join('\n')}, {root: true});
          reject(error);
        });
      });
    },
  },
};

export default zendesk;
